<template>
 <div class="slide-gallery">
  <div class="sb-logo">
    <img src="/static/img/logo.png" />
  </div>
  <div class="slide-messages">
    <span class="slide-message pos-1">
      {{ $t('slide_1') }}
    </span>
    <span class="slide-message pos-2">
      {{ $t('slide_2') }}
    </span>
    <span class="slide-message pos-3">
      {{ $t('slide_3') }}
    </span>
  </div>
  <a class="download-flyer" download href="/static/files/Shipping Board.pdf">
    <button class="btn-green">
      {{ $t('download_flyer') }}
    </button>
  </a>
</div>
</template>
<script>
export default {
  name: 'slide-gallery'
}
</script>
<style lang="scss">
  @import '../../assets/scss/variables.scss';
.slide-gallery {
  background-image:
  linear-gradient(to right, #00000070 35%, rgba(0, 0, 0, 0)),
  url("/../../../static/img/presentation.jpg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
  padding-top: 3em;
  height: 45em;
  max-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
}
.sb-logo {
  max-width: 88%;
  width: 30em;
  margin: 3em 6%;
  img {
    filter: invert(1);
  }
}
.slide-gallery-msg {
  color: white;
  box-sizing: border-box;
  display: inline-block;
  font-size: 4em;
  margin-left: 6%;
  width: 17em;
  max-width: 94%;
  font-family: MuseoSans-900;
  text-transform: uppercase;
  line-height: 1em;
}

.download-flyer {
  position: absolute;
  right: .5em;
  bottom: .5em;
}
.slide-messages {
  flex: 1;
  margin: 0 6%;
  position: relative;
  .slide-message {
    color: $k-lime;
    font-size: 3em;
    font-family: MuseoSans-900;
    text-transform: uppercase;
    line-height: 1em;
    display: block;
    width: 16em;
    max-width: 100%;
    position: absolute;
    opacity: 0;
    animation: message 9s infinite;
    &.pos-2 {
      animation-delay: 3s;
    }
    &.pos-3 {
      animation-delay: 6s;
    }
  }
}

@keyframes message{
  5%, 35% {
    opacity: 1;
    transform: translateY(2em);
  }

  40%, 70% {
    opacity: 0;
    transform: translateY(6em);
  }

  75%, 100%, 0% {
    opacity: 0;
    transform: translateY(-2em);
  }
}
@media screen and (max-width: 900px) {
  .slide-gallery-msg {
    font-size: calc(1.8em + 3vw)
  }
  .slide-messages {
    .slide-message {
      font-size: calc(1.3em + 3vw);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/product/SlideGallery.vue